import { BlueprintRepository } from "./blueprint-repository";

export const getOrganization = () => {
  const repo = new BlueprintRepository();
  return repo.getOrganization();
};
